const FANG_URL = "http://localhost:8112/";
const XUAN_URL = "http://192.168.1.47:8111";
const YUAN_URL = "http://192.168.1.92:8111";
const XU_URL = "http://192.168.1.41:8111/";
const WANG_URL = "http://192.168.1.82:8111";
const LOCAL_URL = "http://localhost:8111";
const ZHANG_URL = "http://192.168.1.53:8111";
const CHEN_URL = "http://192.168.1.57:8111/";
const DEV_SITE_URL = "http://124.223.173.176:8112/";
const PROD_URL = "https://prod-api.fangcangwang.com/";
const TEST_URL = PROD_URL;
const DEV_URL = ZHANG_URL;
// 用于前端需要同时开启多个服务时，可以使用,可以分别npm run dev 和 npm run test分别启动连接不同后端服务的前端服务
const SH_MANIFEST_VGM_PROD_URL = "https://sh-manifest-vgm-api.fangcangwang.com";
const SH_MANIFEST_VGM_LOCAL_URL = "http://192.168.1.41:18216";
const SH_MANIFEST_VGM_TEST_URL = SH_MANIFEST_VGM_LOCAL_URL;
// 拓客
const TOKER_PROD_URL = "https://tk.fangcangwang.com";
// const TOKER_TEST_URL = DEV_SITE_URL;
const TOKER_TEST_URL = "http://192.168.1.41:8210";
const TOKER_LOCAL_URL = "http://192.168.1.64:8210";
// 义乌市场采购
const ASSISTANT_PROD_URL = "https://yiwu-api.nbhuojian.com";
// const ASSISTANT_PROD_URL = "http://192.168.1.31:8155";
const ASSISTANT_LOCAL_URL = "http://localhost:8155";
const ASSISTANT_TEST_URL = "http://124.223.173.176:8155";
// const ASSISTANT_LOCAL_URL = "http://192.168.1.41:8155";
// 国外订阅
const ABROAD_PROD_URL = "https://prod-api.fangcangwang.com";
const ABROAD_TEST_URL = TEST_URL;
const ABROAD_LOCAL_URL = XU_URL;
// 货代英雄联盟
const YXLM_PROD_URL = "https://yxlm.fangcangwang.com";
const YXLM_TEST_URL = "http://localhost:18310";
// 9810/9710 跨境电商报关
const PRE9810_PROD_URL = "https://kj.fangcangwang.com";
// const PRE9810_TEST_URL = "http://192.168.1.41:18512";
const PRE9810_LOCAL_URL = "http://192.168.1.41:18512";
const PRE9810_TEST_URL = PRE9810_LOCAL_URL;
const QD_MANIFEST_LOCAL_URL = "http://localhost:8221/qdManifest/";
const QD_MANIFEST_TEST_URL = "http://124.223.173.176:8221/qdManifest/";
const QD_MANIFEST_PROD_URL = "https://qdcd-api.fangcangwang.com/";
// const YXLM_TEST_URL = "http://192.168.1.41:18310";
// const ASSISTANT_LOCAL_URL = ASSISTANT_PROD_URL;
// 用于前端需要同时开启多个服务时，可以使用,可以分别npm run dev 和 npm run test分别启动连接不同后端服务的前端服务
// api文件夹下接口配置
export const baseEnum = {
    production: PROD_URL,
    test: TEST_URL,
    // test: "https://prod-api.fangcangwang.com/",
    // development: "http://124.223.173.176:8111/",
    development: DEV_URL,
    // development: DEV_URL,
};

// axios文件夹下接口配置
export const axiosEnum = {
    // production: "https://fcw.fangcangwang.com/",
    production: PROD_URL,
    test: TEST_URL,
    // test: "https://prod-api.fangcangwang.com/",
    // development: "http://124.223.173.176:8111/",
    development: DEV_URL,
    // development: DEV_URL,
};

// 宁波舱单
export const axios4Enum = {
    production: "https://fcw.fangcangwang.com/nbManifest/",
    test: TEST_URL,
    // development: "http://124.223.173.176:8111/nbManifest/",
    // development: "https://fcw.fangcangwang.com/nbManifest/",
    development: `${DEV_URL}/nbManifest/`,
};

// 宁波舱单导出
export const axios8Enum = {
    production: PROD_URL,
    test: `${TEST_URL}/manifest/`,
    // development: "http://116.62.132.32:8186/manifest/",
    development: DEV_URL,
    // development: `${DEV_URL}/manifest/`,
};

// 上海舱单
export const axios5Enum = {
    production: `${SH_MANIFEST_VGM_PROD_URL}/shManifest/`,
    test: `${SH_MANIFEST_VGM_TEST_URL}/shManifest/`,
    development: `${SH_MANIFEST_VGM_TEST_URL}/shManifest/`,
};

// 青岛舱单
export const axiosQdManifestEnum = {
    production: `${QD_MANIFEST_PROD_URL}qdManifest/`,
    test: `${TEST_URL}/qdManifest/`,
    // development: "http://124.223.173.176:8111/qdManifest/",
    development: QD_MANIFEST_LOCAL_URL,
    // development: `${DEV_URL}/qdManifest/`,
};

// VGM
export const axiosVGMEnum = {
    production: `${SH_MANIFEST_VGM_PROD_URL}/vgm/`,
    test: `${SH_MANIFEST_VGM_TEST_URL}/vgm/`,
    development: `${SH_MANIFEST_VGM_TEST_URL}/vgm/`,
};

// 义乌报关助手
export const axiosHeadEnum = {
    production: `${ASSISTANT_PROD_URL}/assistant`,
    test: `${ASSISTANT_PROD_URL}/assistant`,
    // test: `${ASSISTANT_LOCAL_URL}/assistant`,
    development: `${ASSISTANT_LOCAL_URL}/assistant`,
};

// 预录单
export const axios6Enum = {
    production: "http://47.110.59.188:8081/",
    test: "http://192.168.1.30:10001/",
    development: "http://124.223.173.176:10001/",
};

// 支付
export const axios7Enum = {
    production: `${PROD_URL}`,
    test: TEST_URL,
    // test: "https://prod-api.fangcangwang.com/",
    // development: "http://124.223.173.176:8111",
    development: `${DEV_URL}`,
    // development: DEV_URL,
};

// 拓客
export const axiosTokerEnum = {
    production: `${TOKER_PROD_URL}/tk/`,
    test: `${TOKER_TEST_URL}/tk/`,
    development: `${TOKER_TEST_URL}/tk/`,
};

// 国外订阅
export const axiosAbroadEnum = {
    production: `${ABROAD_PROD_URL}/`,
    test: `${ABROAD_TEST_URL}/`,
    development: `${ABROAD_LOCAL_URL}/`,
};

export const axiosAbroadOrderEnum = {
    production: `${PROD_URL}/`,
    test: `${TEST_URL}/`,
    development: `${ABROAD_LOCAL_URL}/`,
};

// 货代英雄联盟
export const axiosYXLMEnum = {
    production: `${YXLM_PROD_URL}/yxlm`,
    test: `${YXLM_TEST_URL}/yxlm`,
    development: `${DEV_URL}/yxlm`,
};

export const axiosEnum_JDWX = {
    production: "https://jd-wx-program.nbhuojian.com/",
    test: "https://jd-wx-program.nbhuojian.com/",
    development: "https://jd-wx-program.nbhuojian.com/",
};

export const SHIP_SEARCH_URL = "https://searchv3.shipxy.com";

export const GPS_SEARCH = "https://dataq.4portun.com:81";

// 9810/9710 跨境电商报关
export const axios9810Enum = {
    production: PRE9810_PROD_URL,
    test: PRE9810_TEST_URL,
    development: PRE9810_LOCAL_URL,
};

// 宁波舱单制作（无草单识别）
export const nbManifestMakeEnum = {
    production: "https://nbcd-api.fangcangwang.com",
    // test: "https://nb-manifest.fangcangwang.com",
    // test:"http://192.168.1.57:8080",
    // test:"https://nbcd-api.fangcangwang.com",
    // test: TEST_URL,
    test: "http://192.168.1.57:8080",
    // development: "https://nbcd-api.fangcangwang.com",
    development: "http://192.168.1.57:8080",
};
